import { useMutation, useQuery } from 'react-query';
import { HRScoringParameterService } from '@api/HRScoringParameterService';
import { onDefaultError } from '../helpers/commonHelpers';

// Records
const useListHRScoringParameter = (
  [page_no, searchText, selectedStatus, selectedEmployeeType],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['hr-scoring-parameter-list', page_no, searchText, selectedStatus, selectedEmployeeType],
    HRScoringParameterService.listHRScoringParameter,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

// Create
const useAddHRScoringParameter = (onSuccess, onError = onDefaultError) => {
  return useMutation(HRScoringParameterService.addHRScoringParameter, {
    onSuccess,
    onError
  });
};
// Details
const useViewHRScoringParameter = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('hr-scoring-parameter-view', () => HRScoringParameterService.viewHRScoringParameter(id), {
    onSuccess,
    onError
  });
};

// Details
const useShowHRScoringParameter = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('hr-scoring-parameter-show', () => HRScoringParameterService.showHRScoringParameter(id), {
    onSuccess,
    onError
  });
};

const useUpdateHRScoringParameter = (onSuccess, onError = onDefaultError) => {
  return useMutation(HRScoringParameterService.updateHRScoringParameter, {
    onSuccess,
    onError
  });
};

// Delete
const useDeleteHRScoringParameter = (onSuccess, onError = onDefaultError) => {
  return useMutation(HRScoringParameterService.deleteHRScoringParameter, {
    onSuccess,
    onError
  });
};

const useUpdateHRScoringParameterStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(HRScoringParameterService.changeStatusHRScoringParameter, {
    onSuccess,
    onError
  });
};

// Graph
const useGetGraphData = (
  [employeeId, startDate, endDate, parameters, scoredBy],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['hr-scoring-graph-data', employeeId, startDate, endDate, parameters, scoredBy],
    HRScoringParameterService.getGraphData,
    {
      enabled: !!(employeeId),
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

const useGetMyGraphData = (
  [startDate, endDate, parameters],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['my-graph-hr-scoring-data', startDate, endDate, parameters],
    HRScoringParameterService.getMyGraphData,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

const useGetAvailableMonths = (onSuccess, onError) => {
  return useQuery(
    ['available-months-hr-scoring'],
    HRScoringParameterService.getAvailableMonths,
    {
      onSuccess,
      onError,
      refetchOnMount: true, // Always refetch when component mounts
      refetchOnWindowFocus: false, // Don't refetch on window focus
      staleTime: 0, // Consider data stale immediately
      cacheTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    }
  );
};

const useGetEmployeeAvailableMonths = ([employeeId], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['employee-available-months', employeeId],
    HRScoringParameterService.getEmployeeAvailableMonths,
    {
      enabled: !!employeeId,     // Only fetch when employeeId exists
      onSuccess,
      onError,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
    }
  );
};

export {
  useListHRScoringParameter,
  useAddHRScoringParameter,
  useViewHRScoringParameter,
  useUpdateHRScoringParameter,
  useDeleteHRScoringParameter,
  useUpdateHRScoringParameterStatus,
  useShowHRScoringParameter,
  useGetGraphData,
  useGetMyGraphData,
  useGetAvailableMonths,
  useGetEmployeeAvailableMonths
};
